import React, { useEffect, useState } from "react";
import "./Cart_Products_card.css";
import { Table } from "react-bootstrap";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import Increment_decrement_btn_holder_add from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder_add";
import { deleteAllCart, getAllCart } from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId, RolesIds, variant_type } from "../../../utils/common";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import NoData from "../../Animation/no_data/NoData";

function Cart_Products_card({ data, instock, setInstock, isVendor }) {
  const isSignin = useSelector((state) => state.auth.is_signin);

  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({ id, isSignin, product_id, varient_id }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Error:", res.payload || "Not In Cart");
    }
  };
  const navigate = useNavigate();
  // useEffect(() => {
  //   if (data?.data?.length > 0) {
  //     const anyOutOfStock = data.data.some((val) => {
  //       let stock = 0;

  //       if (
  //         Number(val?.Product?.variant_type_id) === Number(variant_type.Single)
  //       ) {
  //         stock = Number(val?.Product_Variant?.general_stock);
  //       } else if (
  //         Number(val?.Product?.variant_type_id) === Number(variant_type.Double)
  //       ) {
  //         stock = Number(val?.Double_Variant?.stock);
  //       } else if (
  //         Number(val?.Product?.variant_type_id) === Number(variant_type.Triple)
  //       ) {
  //         stock = Number(val?.Triple_Variant?.stock);
  //       }

  //       const quantity = Number(val?.quantity);

  //       return stock < quantity;
  //     });

  //     setInstock(anyOutOfStock);
  //   } else {
  //     setInstock(false);
  //   }
  // }, [data]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  return (
    <>
      <section className="Cart_Products_card">
        <div className="back_holder" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />

          <span>Back</span>
        </div>

        {/* <div className="ContinueShopping_text">
            <Link to={"/categories"}>
              <p>Continue Shopping</p>
            </Link>
          </div> */}
        <div className="desktop_viw_table_holder">
          <div className="table-responsive">
            <Table>
              <thead>
                <tr>
                  <th>Product</th>
                  <th className="text-center">Unit Price</th>
                  <th className="text-center">Quantity</th>
                  <th className="text-center">
                    <b>Subtotal</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.length > 0 ? (
                  data.data.map((val) => {
                    let stock;
                    if (
                      Number(val?.Product?.variant_type_id) ===
                      Number(variant_type.Single)
                    ) {
                      stock = Number(val?.Product_Variant?.general_stock);
                    } else if (
                      Number(val?.Product?.variant_type_id) ===
                      Number(variant_type.Double)
                    ) {
                      stock = Number(val?.Double_Variant?.stock);
                    } else if (
                      Number(val?.Product?.variant_type_id) ===
                      Number(variant_type.Triple)
                    ) {
                      stock = Number(val?.Triple_Variant?.stock);
                    }
                    const isInstock = stock <= val?.quantity;
                    const isInstockerror = stock < val?.quantity;
                    const quantity = Number(val?.quantity);

                    const mrp = Number(
                      val.Triple_Variant?.mrp ||
                        val.Double_Variant?.mrp ||
                        val.Product_Variant?.mrp,
                    );

                    const price = Number(
                      val.Triple_Variant?.price ||
                        val.Double_Variant?.price ||
                        val.Product_Variant?.price,
                    );
                    const b2bPrice = Number(
                      val.Triple_Variant?.b2b_price ||
                        val.Double_Variant?.b2b_price ||
                        val.Product_Variant?.b2b_price,
                    );

                    const finalmrp = Number(mrp * rate).toFixed(2);
                    const finalprice = Number(price * rate).toFixed(2);
                    const finalB2bPrice = Number(b2bPrice * rate).toFixed(2);

                    return (
                      <tr key={val.id ?? `${val.product_id}-${val.variant_id}`}>
                        <td className="td1">
                          <div className="row align-items-start">
                            <div
                              className="col-lg-5 col-12 pe-0"
                              // onClick={() =>
                              //   navigate(
                              //     `/product-details/${encodeId(
                              //       val.product_id,
                              //     )}`,
                              //   )
                              // }
                              style={{ cursor: "pointer" }}
                            >
                              <div className="left_div">
                                <div className="delete_div">
                                  <FontAwesomeIcon
                                    className="trash_icon"
                                    icon={faTrashCan}
                                    onClick={() =>
                                      deleteCart(
                                        val.id,
                                        val.product_id,
                                        val.variant_id,
                                      )
                                    }
                                  />
                                </div>

                                <div
                                  className="img_holder"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    navigate(
                                      `/product-details/${encodeId(
                                        val.product_id,
                                      )}`,
                                    )
                                  }
                                >
                                  <img
                                    className="Product_img"
                                    src={`${process.env.REACT_APP_IMG_URL}${val.Product?.image}`}
                                    alt={val.Product?.name || "Product image"}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-7 col-12">
                              <div className="info_text_holder">
                                <div>
                                  <h4>{val.Product?.name}</h4>

                                  <h6>
                                    Size:{" "}
                                    <span>
                                      {val?.Product_Variant?.Metal?.name ||
                                        val?.Double_Variant?.Product_Variant
                                          ?.Metal?.name ||
                                        val?.Triple_Variant?.Double_Variant
                                          ?.Product_Variant?.Metal?.name}
                                    </span>
                                  </h6>

                                  {/* {instock && isInstockerror && (
                                    <p className="text-danger mt-2">
                                      Out of stock (Available: {stock})
                                    </p>
                                  )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td className="td2">
                          <div className="price_holder">
                            {isVendor ? (
                              <p className="price_text">
                                {symbol} {Number(finalB2bPrice).toFixed(2)}{" "}
                              </p>
                            ) : (
                              <p className="price_text">
                                {symbol} {Number(finalprice).toFixed(2)}{" "}
                              </p>
                            )}
                          </div>
                        </td>

                        <td className="td3">
                          <div className="Quantity_tr_holder justify-content-center flex-column">
                            {isVendor && (
                              <small className="text-muted d-block mb-2">
                                Min Qty:{" "}
                                {Number(
                                  val?.Triple_Variant?.b2b_min_quanity ||
                                    val?.Double_Variant?.b2b_min_quanity ||
                                    val?.Product_Variant?.b2b_min_quanity ||
                                    1,
                                )}
                              </small>
                            )}
                            <Increment_decrement_btn_holder_add
                              val={val}
                              quantity={val.quantity}
                              setInstock={setInstock}
                              setError={(msg) =>
                                setError((prev) => ({
                                  ...prev,
                                  [val.id]: msg,
                                }))
                              }
                              error={error}
                              isInstock={isInstock}
                            />

                            <div className="delete_div tabview">
                              <FontAwesomeIcon
                                className="trash_icon"
                                icon={faTrashCan}
                                onClick={() =>
                                  deleteCart(
                                    val.id,
                                    val.product_id,
                                    val.variant_id,
                                  )
                                }
                              />
                            </div>

                            {error[val.id] && (
                              <p className="text-danger">{error[val.id]}</p>
                            )}
                          </div>
                        </td>

                        <td className="td4">
                          <div className="price_holder">
                            {isVendor ? (
                              <p className="price_text">
                                {symbol}{" "}
                                {Number(
                                  finalB2bPrice * Number(val?.quantity),
                                ).toFixed(2)}{" "}
                              </p>
                            ) : (
                              <p className="price_text">
                                {symbol}{" "}
                                {Number(
                                  finalprice * Number(val.quantity),
                                ).toFixed(2)}{" "}
                              </p>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      <NoData
                        text="Your cart is empty"
                        subText="Add some products to see them here"
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="mobile_view_table_holder">
          {data?.data?.map((val, index) => {
            // ✅ get mrp & price for each item
            let stock;
            if (
              Number(val?.Product?.variant_type_id) ===
              Number(variant_type.Single)
            ) {
              stock = Number(val?.Product_Variant?.general_stock);
            } else if (
              Number(val?.Product?.variant_type_id) ===
              Number(variant_type.Double)
            ) {
              stock = Number(val?.Double_Variant?.stock);
            } else if (
              Number(val?.Product?.variant_type_id) ===
              Number(variant_type.Triple)
            ) {
              stock = Number(val?.Triple_Variant?.stock);
            }
            const isInstock = stock <= val?.quantity;
            const isInstockerror = stock < val?.quantity;
            const quantity = Number(val?.quantity);

            const mrp = Number(
              val.Triple_Variant?.mrp ||
                val.Double_Variant?.mrp ||
                val.Product_Variant?.mrp,
            );

            const price = Number(
              val.Triple_Variant?.price ||
                val.Double_Variant?.price ||
                val.Product_Variant?.price,
            );
            const b2bPrice = Number(
              val.Triple_Variant?.b2b_price ||
                val.Double_Variant?.b2b_price ||
                val.Product_Variant?.b2b_price,
            );

            const finalmrp = Number(mrp * rate).toFixed(2);
            const finalprice = Number(price * rate).toFixed(2);
            const finalB2bPrice = Number(b2bPrice * rate).toFixed(2);

            return (
              <div className="mobile_product_card" key={index}>
                <div className="row ">
                  <div className="col-4">
                    <div
                      className="img_holder"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/product-details/${encodeId(val.product_id)}`)
                      }
                    >
                      <img
                        src={
                          process.env.REACT_APP_IMG_URL + val?.Product?.image
                        }
                        className="prod_img"
                        alt="product"
                      />
                    </div>
                  </div>

                  <div className="col-8">
                    <div className="descn_holder">
                      <p className="product_name">{val?.Product?.name}</p>

                      {/* ✅ price display */}
                      <p className="price_text">
                        {isVendor ? (
                          <p className="price_text">
                            {symbol} {Number(finalB2bPrice).toFixed(2)}{" "}
                          </p>
                        ) : (
                          <p className="price_text">
                            {symbol} {Number(finalprice).toFixed(2)}{" "}
                          </p>
                        )}
                      </p>

                      <p className="weight_text">
                        Size:
                        <span>
                          {val?.Product_Variant?.Metal?.name ||
                            val?.Double_Variant?.Product_Variant?.Metal?.name ||
                            val?.Triple_Variant?.Double_Variant?.Product_Variant
                              ?.Metal?.name}
                        </span>
                        {/* {instock && isInstockerror && (
                          <p className="text-danger mt-2">
                            Out of stock (Available: {stock})
                          </p>
                        )} */}
                      </p>

                      <div className="all_btns_holder">
                        <div className="Quantity_tr_holder">
                          <Increment_decrement_btn_holder_add
                            val={val}
                            quantity={val?.quantity}
                            error={error[val.id]}
                            setError={(msg) =>
                              setError((prev) => ({
                                ...prev,
                                [val.id]: msg,
                              }))
                            }
                            setInstock={setInstock}
                          />

                          <div className="delete_div">
                            <FontAwesomeIcon
                              className="trash_icon"
                              icon={faTrashCan}
                              onClick={() =>
                                deleteCart(
                                  val.id,
                                  val.product_id,
                                  val.variant_id,
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}

export default Cart_Products_card;
